.dismissButton {
  position: absolute;
  right: -10px;
  top: -10px;
}

.promptIcon {
  color: color-mix(in srgb, var(--colors-primary-main) 50%, white);
  position: relative;
}

@media all and (--reefer-media-tablet-min) {
  .container {
    display: none;
  }
}
